import { useEffect, useMemo } from 'react';
import styleUrl from '../../assets/2021/css/style.css?url';
import alertStyleUrl from '../../assets/2021/css/newsAlertStyle.css?url';
import { Lang2021, menu2021 } from './data';
import { cleanup2021Runtime, mount2021Runtime } from './runtime';

export const getLang2021 = (): Lang2021 => {
  const lang = new URLSearchParams(window.location.search).get('lang');
  return lang === 'zh' ? 'zh' : 'en';
};

export const make2021Href = (path: string, lang: Lang2021) => {
  const [rawPath, rawQuery] = path.split('?');
  const normalizedPath = (rawPath || '')
    .replace(/^\/+/, '')
    .replace(/\.php$/i, '')
    .trim();

  const base = normalizedPath === '' || normalizedPath === 'index' ? '/2021' : `/2021/${normalizedPath}`;

  const params = new URLSearchParams(rawQuery || '');
  if (lang === 'zh') {
    params.set('lang', 'zh');
  }

  const query = params.toString();
  return query ? `${base}?${query}` : base;
};

export const use2021Page = (title: string) => {
  const lang = useMemo(() => getLang2021(), []);
  useEffect(() => {
    document.title = title;
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    const links: HTMLLinkElement[] = [];
    [styleUrl, alertStyleUrl].forEach((href) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.setAttribute('data-year-style', '2021');
      document.head.appendChild(link);
      links.push(link);
    });
    mount2021Runtime();
    // Some browsers/router states restore previous scroll position on refresh.
    // Force 2021 pages to start from top consistently.
    requestAnimationFrame(() => window.scrollTo(0, 0));
    setTimeout(() => window.scrollTo(0, 0), 0);
    setTimeout(() => window.scrollTo(0, 0), 120);
    return () => {
      cleanup2021Runtime();
      links.forEach((l) => l.remove());
    };
  }, [title]);
  return { lang };
};

export const Header2021 = ({ lang, currentPath }: { lang: Lang2021; currentPath: string }) => {
  const switchLang = lang === 'zh' ? 'en' : 'zh';
  const baseSearch = new URLSearchParams(window.location.search);
  baseSearch.set('lang', switchLang);
  const langHref = `${window.location.pathname}?${baseSearch.toString()}`;

  return (
    <header>
      <div style={{ display: 'flex', backgroundColor: '#083050', position: 'fixed', zIndex: 999, width: '100%' }}>
        <div className="menu-left" style={{ display: 'inline-block', textAlign: 'center' }}>
          <a href={make2021Href('index', lang)}>
            <img id="logo" className="logo" src="/2021/images/logo.png" alt="logo" />
          </a>
        </div>
        <div className="menu-right" style={{ display: 'inline-block' }}>
          <div className="menu-item">
            <a href={make2021Href('awards', lang)}>{menu2021[lang].awards}</a>
            <a href={make2021Href('judges', lang)}>{menu2021[lang].judges}</a>
            <a href={make2021Href('highlight', lang)}>{menu2021[lang].highlight}</a>
            <a href={make2021Href('sponsors', lang)}>{menu2021[lang].sponsor}</a>
            <a href={lang === 'zh' ? '/2018/zh' : '/2018'}>{menu2021[lang].events}</a>
            <a href={langHref}>
              <div style={{ display: 'flex', marginTop: lang === 'en' ? '-2px' : '3px' }}>
                <img src="/2021/images/globe.svg" alt="lang" />
                <span style={{ marginTop: '-2px' }}>{lang === 'zh' ? 'EN' : '中'}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div style={{ height: currentPath === 'index' ? '0' : '0' }} />
    </header>
  );
};

export const Footer2021 = ({ lang }: { lang: Lang2021 }) => (
  <>
    <div className="footer-container">
      <div style={{ width: '50%' }}>
        <img style={{ width: '55%' }} src="/2021/images/logo_footer.png" alt="" />
        <div className="footer-share-text">
          <a style={{ marginTop: 15 }} href="#">{lang === 'zh' ? '活動查詢 (+852) 2880 2950 或 (+852) 2880 7088 | smartcityawards@etnet.com.hk' : 'Event Enquiries +852 2880 2950 or +852 2880 7088 | smartcityawards@etnet.com.hk'}</a>
        </div>
        <div className="footer-share-icon">
          <a style={{ marginRight: 20, position: 'relative', top: -10 }}>{lang === 'zh' ? '分享到' : 'Share to'}</a>
          <a href={lang === 'zh' ? 'https://www.facebook.com/sharer.php?u=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2021%3Flang%3Dzh' : 'https://www.facebook.com/sharer.php?u=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2021'} target="_blank" rel="noreferrer"><img style={{ width: 40, marginRight: 10 }} src="/2021/images/facebook.png" alt="facebook" /></a>
          <a href={lang === 'zh' ? 'https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2021%3Flang%3Dzh' : 'https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2021'} target="_blank" rel="noreferrer"><img style={{ width: 40, transform: 'scale(1.2)' }} src="/2021/images/linkedin.png" alt="linkedin" /></a>
        </div>
      </div>
      <div style={{ width: '50%' }}>
        <div style={{ display: 'flex', marginBottom: 30 }}>
          <div className="organiser"><p><b>{lang === 'zh' ? '主辦機構' : 'Organiser'}</b></p><img style={{ width: 155 }} src="/2021/images/etnet.png" alt="" /></div>
          <div className="co_organiser"><p><b>{lang === 'zh' ? '協辦機構' : 'Co-organiser'}</b></p><img style={{ width: 155, paddingTop: 15 }} src="/2021/images/cyberport.png" alt="" /></div>
        </div>
        <div style={{ display: 'flex', marginBottom: 45 }}>
          <div className="knowledge"><p><b>{lang === 'zh' ? '知識夥伴' : 'Knowledge Partner'}</b></p><img src="/2021/images/pwc.png" alt="" /></div>
          <div className="strategic"><p><b>{lang === 'zh' ? '策略夥伴' : 'Strategic Partners'}</b></p><img src="/2021/images/EY.png" alt="" /><img src="/2021/images/KPMG.png" alt="" /><img src="/2021/images/SCC.png" alt="" /></div>
        </div>
        <div style={{ marginBottom: 20 }}>
          <p><b>{lang === 'zh' ? '贊助機構' : 'Sponsors'}</b></p>
          <img src="/2021/images/deloitte.png" style={{ width: 120, marginRight: 15 }} alt="" />
          <img src="/2021/images/EDGR.png" style={{ width: 120, marginRight: 15 }} alt="" />
          <img src="/2021/images/GBABS.png" style={{ width: 120, marginRight: 15 }} alt="" />
          <img src="/2021/images/pokka.png" style={{ width: 120, marginRight: 15 }} alt="" />
        </div>
        <p><b>{lang === 'zh' ? '支持機構' : 'Supporting Organisations'}</b></p>
        <div className="support">
          {['FHKI', 'GS1', 'IOTA', 'HKNA', 'HKPC', 'HKRTIA', lang === 'zh' ? 'HKSTP_TC' : 'HKSTP', 'LSCM', 'Opo', 'rfid', 'smuhk', 'TIN', 'ACMCP'].map((x) => (
            <img key={x} style={{ width: 90, marginRight: 15 }} src={`/2021/images/${x}.png`} alt={x} />
          ))}
        </div>
      </div>
    </div>
    <div className="bottom-p"><p>{lang === 'zh' ? '© 2021 經濟通有限公司 版權所有 不得轉載' : '© 2021 ET Net Limited. All rights reserved.'}</p></div>
  </>
);
